// extracted by mini-css-extract-plugin
module.exports = {"item-border-bottom":"style_item-border-bottom__20aCa"};